import { z } from "zod";

export const configSchema = z.object({
	url: z.string(),
	auth_url: z.string(),
	base_path: z.string(),
	show_ldap: z.boolean(),
	is_dev: z.boolean(),
	lucid_url: z.string(),
	console_url: z.string(),
});

export type ApplicationConfig = z.infer<typeof configSchema>;
